export default __webpack_public_path__ + "locales/cs/SMTPSettings.json?hash=2b6156b13a340daeca95dc6be7091698";